var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C3.592 0.5 0 4.092 0 8.5C0 12.908 3.592 16.5 8 16.5C12.408 16.5 16 12.908 16 8.5C16 4.092 12.408 0.5 8 0.5ZM11.2 9.1H8.6V11.7C8.6 12.028 8.328 12.3 8 12.3C7.672 12.3 7.4 12.028 7.4 11.7V9.1H4.8C4.472 9.1 4.2 8.828 4.2 8.5C4.2 8.172 4.472 7.9 4.8 7.9H7.4V5.3C7.4 4.972 7.672 4.7 8 4.7C8.328 4.7 8.6 4.972 8.6 5.3V7.9H11.2C11.528 7.9 11.8 8.172 11.8 8.5C11.8 8.828 11.528 9.1 11.2 9.1Z",
    fill: "#8EC1A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusFill);
export default __webpack_public_path__ + "static/media/plus-fill.a79ade859676a62cfe09c0b609718520.svg";
export { ForwardRef as ReactComponent };